import axios from "axios";
import { inject, injectable } from "inversify";
import { ApiCallService } from "./apiCall.service";
import { AuthService } from "./authService";
import {
  ResourceFiltersInterface,
  Resources,
  ResourceUpload,
} from "../interface/ResourcesInterface";
import { PagingInterface } from "../interface/PaginationInterface";

@injectable()
export class ResourceService {
  constructor(
    @inject(ApiCallService) public apiCallService: ApiCallService,
    @inject(AuthService) public authService: AuthService,
  ) {}

  public async addResource(formData: ResourceUpload): Promise<ResourceUpload> {
    return axios
      .post<ResourceUpload>(
        this.apiCallService.apiUrl(`resources/pdf`),
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      )
      .then((result) => result.data);
  }

  public async addResourceYt(
    formData: ResourceUpload,
  ): Promise<ResourceUpload> {
    return axios
      .post<ResourceUpload>(
        this.apiCallService.apiUrl("resources/yt-video"),
        formData,
      )
      .then((result) => result.data);
  }

  public async fetchResources(
    resourceFilters: Partial<ResourceFiltersInterface>,
    pageConfig: { page?: number; offset?: number } = {
      page: 1,
      offset: 8,
    },
  ): Promise<PagingInterface<Resources>> {
    return axios
      .get<PagingInterface<Resources>>(
        this.apiCallService.apiUrl("resources", {
          ...resourceFilters,
          ...pageConfig,
        }),
      )
      .then((result) => result.data);
  }

  public async deleteResource(
    resourcesId: number,
  ): Promise<{ status: string }> {
    return axios
      .delete<{
        status: string;
      }>(this.apiCallService.apiUrl(`resources/${resourcesId}`))
      .then((result) => result.data);
  }
}
